"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemValueWaitingPeriod = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ProductItemValueWaitingPeriod = exports.ProductItemValueWaitingPeriod = function ProductItemValueWaitingPeriod(_ref) {
  var waitingPeriodMessages = _ref.waitingPeriodMessages,
    planNumber = _ref.planNumber,
    selectedProduct = _ref.selectedProduct,
    productGroup = _ref.productGroup;
  if (planNumber) {
    var isSelected = selectedProduct && (planNumber === selectedProduct.planNumber || selectedProduct.basePlanNo === planNumber);
    return waitingPeriodMessages.map(function (item) {
      var _item$excludedPlans;
      return (item === null || item === void 0 ? void 0 : item.messages) && !(item !== null && item !== void 0 && (_item$excludedPlans = item.excludedPlans) !== null && _item$excludedPlans !== void 0 && _item$excludedPlans.includes(productGroup)) && /*#__PURE__*/_react["default"].createElement("td", {
        key: "waitingPeriodMessages_".concat(item.id),
        className: "waitingPeriodMessages ".concat(isSelected ? 'selected' : '')
      }, (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/_react["default"].createElement("div", {
        key: "title_".concat(item.id)
      }, item === null || item === void 0 ? void 0 : item.title), item.messages.map(function (message, index) {
        return (
          /*#__PURE__*/
          /*
          Fix error:Encountered two children with the same key, [object Object].
          Keys should be unique so that components maintain their identity across updates.
          Non-unique keys may cause children to be duplicated and/or omitted —
          the behavior is unsupported and could change in a future version. Error Component Stack
            at div (<anonymous>)
            at td (<anonymous>)
            at ProductItemValueWaitingPeriod (productItemValueWaitingPeriod.js:11:1)
            at ProductItemValue (productItemValue.js:25:1)
             It's ok to use "index" here because the index won't change on the page.
           */
          // eslint-disable-next-line react/no-array-index-key
          _react["default"].createElement("div", {
            key: "message_".concat(item.id, "_").concat(index),
            className: "waitingPeriodMessage"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            key: "condition_".concat(item.id, "_").concat(index),
            className: "condition_".concat(item.id)
          }, message.condition), /*#__PURE__*/_react["default"].createElement("div", {
            key: "waitingPeriod_".concat(item.id, "_").concat(index),
            className: "waiting_period_".concat(item.id)
          }, message.waitingPeriod))
        );
      }));
    });
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "waitingPeriodMessages"
  }, waitingPeriodMessages.join(' '));
};
ProductItemValueWaitingPeriod.propTypes = {
  waitingPeriodMessages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  planNumber: _propTypes["default"].number,
  // eslint-disable-next-line react/forbid-prop-types
  selectedProduct: _propTypes["default"].any,
  productGroup: _propTypes["default"].string
};
var _default = exports["default"] = {
  ProductItemValueWaitingPeriod: ProductItemValueWaitingPeriod
};